import { render, staticRenderFns } from "./ChatComponent.vue?vue&type=template&id=2a38188e&"
import script from "./ChatComponent.vue?vue&type=script&lang=js&"
export * from "./ChatComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports